export default __webpack_public_path__ + "static/media/Leggings of the Putrescent.ccde202f.jpg";